import { HEADER_HAMBURGER_MENU } from "@config/HeaderMenuConstants";
import { HeaderMenuList } from "@header/HeaderMenuList";
import UserInfo from "@header/TopHeader/UserInfo/UserInfo";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

export type HamburgerMenuModalProps = {
  expandMenu: boolean;
};

export function HamburgerMenuModal({
  expandMenu,
}: HamburgerMenuModalProps): ReactElement {
  return (
    <>
      <div
        className={twMerge(
          "lg:hidden sticky top-xxl gap-2 font-primary  overflow-hidden transition-all duration-300 ease-in-out",
          expandMenu
            ? "max-h-screen opacity-100 translate-y-0 border-t border-solid border-gray-600 bg-yellow-100 h-screen z-50"
            : "max-h-0 opacity-0 -translate-y-2 pointer-events-none",
        )}
      >
        <div className="inline-flex w-full justify-evenly py-2 mt-3">
          <UserInfo isHamburger={true} />
        </div>
        <HeaderMenuList
          testId="mobile-main-links"
          items={HEADER_HAMBURGER_MENU}
          type="hamburger"
        />
      </div>
    </>
  );
}
